import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ListaProductosView } from 'src/app/classes/ListaProductosView';

@Injectable({
  providedIn: 'root'
})
export class ListaProductosService {

  constructor(private http: HttpClient) { }

  public getListaTiposProductos(): Observable<Array<ListaProductosView>> {
    const endpoint: string = "../../../assets/Endpoints/Response/getListaProductos.json";
    return this.http.get<any>(endpoint)
      .pipe(
        tap(() => { })
      );
  }
}
